import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable} from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})

export class PartnerService {

  constructor(
    public _http: HttpClient
  ) {}

  getSocios(): Observable<any> {
    let ruta = environment.partnerList;
    return this._http.get(ruta);
  }

  getSocioByFacility(request: any): Observable<any> {
    let ruta = environment.partnerByFacility + request;
    return this._http.get(ruta);
  }

  getPlantas(): Observable<any> {
    let ruta = environment.getPlants;
    return this._http.get(ruta);
  }

  getZonasGeograficas(): Observable<any> {
    let ruta = environment.getZonasGeograficas;
    return this._http.get(ruta);
  }

  getTipoSocio(): Observable<any> {
    let ruta = environment.getTipoSocio;
    return this._http.get(ruta);
  }

  getGrupoAparceria(): Observable<any> {
    let ruta = environment.getGrupoAparceria;
    return this._http.get(ruta);
  }

  getRegionesRecoleccion(): Observable<any> {
    let ruta = environment.getRegionesRecoleccion;
    return this._http.get(ruta);
  }

  getListaGrupoArrendador(): Observable<any> {
    let ruta = environment.getListaGrupoArrendador;
    return this._http.get(ruta);
  }

  getTipoPersona(): Observable<any> {
    let ruta = environment.getTipoPersona;
    return this._http.get(ruta);
  }

  getSocioById(request: any) {
    let ruta = environment.partnerById + request.id;
    return this._http.get(ruta);
  }

  getBankAccountByPartner(request: any) {
    let ruta = environment.bankAccountByPartner + request;
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(ruta, { headers: headersResp });
  }

  getBankAccountById(request: any) {
    let ruta = environment.bankAccountById + request;
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(ruta, { headers: headersResp });
  }

  saveBankAccountPartner(request: any) {
    let ruta = environment.insertBankAccount;
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, request, { headers: headersResp });
  }

  updateBankAccount(request: any, id: any) {
    let ruta = environment.updateBankAccount + "/" + id;    
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(ruta, request, { headers: headersResp });
  }

  getCatRegiones(): any {
    let ruta = environment.catRegion;
    return this._http.get(ruta);
  }

  getCatStates() {
    let ruta = environment.catEstados;
    return this._http.get(ruta);
  }

  getCatMunicipio(id: string) {
    let ruta = environment.catMunicipio + id;
    return this._http.get(ruta);
  }

  getCatRutasRecoleccion() {
    let ruta = environment.catRutasRecoleccion;
    return this._http.get(ruta);
  }

  getCatSucursalesBank() {
    let ruta = environment.catSucursalesBank;
    return this._http.get(ruta);
  }

  getCatRelacionPago() {
    let ruta = environment.catRelacionPago;
    return this._http.get(ruta);
  }

  getCatBanks() {
    let ruta = environment.catBankList;
    return this._http.get(ruta);
  }

  savePartner(request: any) {
    let ruta = environment.savePartner;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  updatePartner(request: any, id: any) {
    let ruta = environment.updatePartner + id;
    return this._http.put(ruta, request);
  }
}